import { BaseController } from '../../base/controller';

export class SignoTecController extends BaseController {
  constructor(controllerService, signoTecService, fakeSignature, $element) {
    'ngInject';
    super({
      controllerService,
      signoTecService,
      fakeSignature,
      $element,
    });
  }

  get connectionStatusMessage() {
    if (this.signoStatus) {
      return this.signoStatus.message;
    }
    return '';
  }

  get signoStatus() {
    if (this.signoTecService && this.signoTecService.status) {
      return this.signoTecService.status;
    }
    return null;
  }

  get errors() {
    if (this.signoTecService && this.signoTecService.errors) {
      return this.signoTecService.errors;
    }
    return null;
  }

  get signatureData() {
    if (this.signoTecService && this.signoTecService.signatureData) {
      return this.signoTecService.signatureData;
    }
    return null;
  }

  get isFakeButtonVisible() {
    return (
      (this.envService.isLocalhost() || this.envService.isDevelopment()) &&
      !this.signatureImage
    );
  }

  get signatureImage() {
    return this.signoTecService.signatureImage;
  }

  set signatureImage(val) {
    this.signoTecService.signatureImage = val;
  }

  get signoPadStatus() {
    return this.signoTecService.status;
  }

  connect() {
    this.signoTecService
      .connect()
      .then(() => {
        this.signoTecService.openPad();
      })
      .catch(() => {
        this.connectionFailed = true;
        this.goToDefault();
        this.signoTecService.killOpenPadInterval();
      });
  }

  $onInit() {
    this.connect();
    this.liveSignment();
  }

  liveSignment() {
    const width = 4000;
    const height = 3000; // don't ask why, just believe it.
    this.canvas = this.$element.find('canvas')[0];
    this.canvas.width = width;
    this.canvas.height = height;
    this.context = this.canvas.getContext('2d');
    this.context.fillStyle = '#ffffff';
    this.context.fillRect(0, 0, width, height);
    this.context.globalAlpha = 1;

    this.signoTecService.setContext(this.context);
  }

  $onDestroy() {
    this.signoTecService.closePad();
    this.signoTecService.disconnect();
    this.signatureImage = null;
  }

  resetSignature() {
    let context = this.canvas.getContext('2d');
    this.signoTecService.resetSignature(context);
    this.signatureImage = '';
    this.signoTecService.clearPad();
    this.connect();
  }

  setFakeSignature() {
    this.signatureImage = this.fakeSignature;
  }

  skipToDefault() {
    this.signoTecService.killOpenPadInterval();
    this.onSkip();
  }

  goToDefault() {
    this.signoTecService.killOpenPadInterval();
    this.onConnectionFailed();
  }
}
